export default {
    configuration: true,
    table: {
        height: 400,
        columns: [
            {
                label: '序号',
                prop: 'index',
                sort: true,
                width: 60
            },
            {
                label: '内容',
                prop: 'content',
                sort: true,
                width: 200
            },
            {
                label: '操作人',
                prop: 'createUserName',
                sort: true,
                width: 100
            },
            {
                label: '修改时间',
                prop: 'createTime',
                sort: true,
                width: 200
            }
        ],
        rows: []
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    }
};
